import { useContext, createContext } from 'react';

const layoutContext = /*#__PURE__*/createContext(undefined);
const actionsContext = /*#__PURE__*/createContext({});
function useElementToolbarActions() {
  return useContext(actionsContext);
}

export { actionsContext, layoutContext, useElementToolbarActions };
//# sourceMappingURL=context.js.map
